export const onHandleKeyDown = (event, handler) => {
  if (event.key === 'Enter') {
    handler(event);
  }
};
